"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constant2 = require("@airasia/phoenix-components/components/Text/constant");
var _constant3 = require("@airasia/phoenix-components/components/Title/constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.oneOf(_constant.Themes),
    accessible: _propTypes.default.bool,
    data: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string,
      description: _propTypes.default.string
    })),
    dataProperties: _propTypes.default.shape({
      sliceLimit: _propTypes.default.number,
      titleColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      titleType: _propTypes.default.oneOf(_constant3.ARR_TITLE_TYPES),
      titleMarginBottom: _propTypes.default.oneOf(_constant.ARR_SPACING_TYPES),
      textColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      textType: _propTypes.default.oneOf(_constant2.ARR_TEXT_TYPE),
      expandCtaText: _propTypes.default.string,
      compressCtaText: _propTypes.default.string,
      ctaColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      ctaSize: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
      ctaUnderlined: _propTypes.default.bool,
      ctaHoverColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      ctaHoverUnderlined: _propTypes.default.bool
    }),
    dataSliceLimit: _propTypes.default.number,
    expandCtaText: _propTypes.default.string,
    compressCtaText: _propTypes.default.string,
    ctaColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    ctaSize: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
    ctaUnderlined: _propTypes.default.bool,
    ctaHoverColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    ctaHoverUnderlined: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    ctaColor: 'secondary',
    ctaSize: _constant.DEFAULT_FONT_SIZE,
    ctaUnderlined: true,
    ctaHoverColor: _constant.DEFAULT_COLOR,
    ctaHoverUnderlined: true
  }
};
exports.default = _default;